module.exports = __webpack_public_path__ + "nucleo-icons.f32ed5ad3d76067b8e43.eot";


//////////////////
// WEBPACK FOOTER
// C:/s4in/azim-tav/src/assets/fonts/nucleo-icons.eot
// module id = ../../../../../src/assets/fonts/nucleo-icons.eot
// module chunks = styles